import React, { useEffect, useState } from "react";
import "../../styles/master-data.css";

export default function MasterDataForm({
  title = "Data Baru",
  fields = [],
  initialValues = {},
  onSubmit,
  onCancel,
  saving = false,
}) {
  const [values, setValues] = useState(initialValues);

  useEffect(() => {
    setValues(initialValues || {});
  }, [initialValues]);

  return (
    <form className="mdf" onSubmit={e => {
      e.preventDefault();
      onSubmit?.(values);
    }}>
      <header>
        <h2>{title}</h2>
        <button type="button" onClick={onCancel}>×</button>
      </header>

      <div className="mdf-body">
        {fields.map(field => <label className="mdf-field" key={field.name}>
          <span>{field.label}{field.required && " *"}</span>
          {field.type === "select" ? (
            <select required={field.required}
              value={values[field.name] ?? ""}
              onChange={e => setValues(v => ({...v,[field.name]:e.target.value}))}>
              <option value="">Pilih…</option>
              {(field.options||[]).map(o =>
                <option key={o.value??o} value={o.value??o}>{o.label??o}</option>)}
            </select>
          ) : field.type === "textarea" ? (
            <textarea required={field.required}
              value={values[field.name] ?? ""}
              onChange={e => setValues(v => ({...v,[field.name]:e.target.value}))}/>
          ) : field.type === "checkbox" ? (
            <input type="checkbox"
              checked={Boolean(values[field.name])}
              onChange={e => setValues(v => ({...v,[field.name]:e.target.checked}))}/>
          ) : (
            <input
              type={field.type || "text"}
              required={field.required}
              placeholder={field.placeholder || ""}
              min={field.min}
              max={field.max}
              step={field.step}
              readOnly={field.readOnly}
              value={values[field.name] ?? field.defaultValue ?? ""}
              onChange={e => setValues(v => ({
                ...v,
                [field.name]: field.type === "number"
                  ? (e.target.value === "" ? "" : Number(e.target.value))
                  : e.target.value
              }))}
            />
          )}
        </label>)}
      </div>

      <footer>
        <button type="button" onClick={onCancel}>Batal</button>
        <button className="mdw-primary" disabled={saving}>
          {saving ? "Menyimpan…" : "Simpan"}
        </button>
      </footer>
    </form>
  );
}
